import { PrimaryText } from "@/shared/ui/Typography";

import { StyledAPPlanContainer } from "../../../Styled";
import { FinGroupFact, PlanDataTuple } from "../InfoTabPlan.model";
import { PlanFinGroupRow, renderValue } from "./PlanFinGroupRow";

interface PlanContentBlockProps {
    activeTab: string;
    hasPointPlan: boolean;
    hasRoutePlan: boolean;
    currentPointPlan: PlanDataTuple[];
    currentRoutePlan: PlanDataTuple[];
    currentPointFinGroupsFact: Record<string, FinGroupFact>;
}

export const PlanContentBlock = ({
    activeTab,
    hasPointPlan,
    hasRoutePlan,
    currentPointPlan,
    currentRoutePlan,
    currentPointFinGroupsFact,
}: PlanContentBlockProps) => {
    let planData: PlanDataTuple[] = [];
    let emptyMessage = "";

    if (activeTab === "tt" && hasPointPlan) {
        planData = currentPointPlan;
        emptyMessage = "План продажів на даний маркет не встановлено";
    } else if (activeTab === "route" && hasRoutePlan) {
        planData = currentRoutePlan;
        emptyMessage = "План продажів на маршрут не встановлено";
    } else {
        return null;
    }

    return (
        <StyledAPPlanContainer>
            {planData.length === 0 ? (
                <PrimaryText
                    fontSize={14}
                    fontWeight="400"
                    style={{ textAlign: "center" }}
                >
                    {emptyMessage}
                </PrimaryText>
            ) : (
                planData.map(([finGroup, finGroupDetails]) => {
                    const fact = currentPointFinGroupsFact[finGroup];

                    return (
                        <PlanFinGroupRow
                            key={finGroup}
                            finGroup={finGroup}
                            b={renderValue(
                                "b",
                                finGroupDetails.type.b,
                                fact?.b,
                            )}
                            l={renderValue(
                                "l",
                                finGroupDetails.type.l,
                                fact?.l,
                            )}
                            m={renderValue(
                                "m",
                                finGroupDetails.type.m,
                                fact?.m,
                            )}
                        />
                    );
                })
            )}
        </StyledAPPlanContainer>
    );
};
